import React from 'react';
import imgQuiz from '../../assets/images/quiz.png';
import imgCrossword from '../../assets/images/crossword.png';
import imgWordSearch from '../../assets/images/wordsearch.png';
export const SelectType = ({ currentStep, setKreeda, setCurrentStep, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Select Type"),
        React.createElement("div", { className: "type-items" },
            React.createElement("div", { className: "type-item", 
                /**
                 * Updates activity type to quiz and advances wizard
                 */
                onClick: () => {
                    setKreeda((kreeda) => ({
                        ...kreeda,
                        type: 'quiz',
                    }));
                    setCurrentStep(currentStep + 1);
                } },
                React.createElement("div", { className: "type-item__heading" },
                    React.createElement("h4", null, "QUIZ")),
                React.createElement("div", { className: "type-item__image" },
                    React.createElement("img", { src: imgQuiz }))),
            React.createElement("div", { className: "type-item", 
                /**
                 * Updates activity type to crossword and advances wizard
                 */
                onClick: () => {
                    setKreeda((kreeda) => ({
                        ...kreeda,
                        type: 'crossword',
                    }));
                    setCurrentStep(currentStep + 1);
                } },
                React.createElement("div", { className: "type-item__heading" },
                    React.createElement("h4", null, "CROSSWORD")),
                React.createElement("div", { className: "type-item__image" },
                    React.createElement("img", { src: imgCrossword }))),
            React.createElement("div", { className: "type-item", 
                /**
                 * Updates activity type to crossword and advances wizard
                 */
                onClick: () => {
                    setKreeda((kreeda) => ({
                        ...kreeda,
                        type: 'word-search',
                    }));
                    setCurrentStep(currentStep + 1);
                } },
                React.createElement("div", { className: "type-item__heading" },
                    React.createElement("h4", null, "WORD SEARCH")),
                React.createElement("div", { className: "type-item__image" },
                    React.createElement("img", { src: imgWordSearch }))))));
};
